import React, { useState } from 'react';
import { Image, Pressable, Text, View } from 'react-native';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import type { GetMyRewardsViewModel } from '../../../api/api.g';
import useCustomTheme from '../../../hooks/theme-hook';
import useTranslation from '../../../hooks/translation-hook';
import { useQualityWarning } from '../../../hooks/useQualityWarning';
import QualityWarningIndicator from '../../common/qualityWarning/QualityWarningIndicator';
import ProfileBonusLink from '../profileBonus/ProfileBonusLink';

export default function MyRewardsCard({ rewards, onPress }: { rewards?: GetMyRewardsViewModel; onPress(): void }) {
  const t = useTranslation();
  const theme = useCustomTheme();
  const { warning } = useQualityWarning();
  const [focused, setFocused] = useState(false);
  const currency = t('currency-value', { value: rewards?.amountCurrency ?? '-' });
  const points = t('points-value', { value: rewards?.amountPts ?? '-' });
  const ink = theme.isDark ? '#DCF4ED' : '#035164';
  const secondaryInk = theme.isDark ? '#B6D6CF' : '#42676C';

  return (
    <View testID="my-rewards-card" style={{ marginTop: 12, borderRadius: 12, overflow: 'hidden',
      backgroundColor: theme.background.primaryLight }}>
      <Pressable testID="my-rewards-summary" accessibilityRole="button" accessibilityLabel={`${t('my_rewards')}, ${currency}, ${points}`}
        onPress={onPress} onFocus={() => setFocused(true)} onBlur={() => setFocused(false)}
        style={({ pressed }) => ({ flexDirection: 'row', alignItems: 'center', paddingHorizontal: 16, paddingVertical: 12, gap: 12, minHeight: 88,
          borderRadius: 10, backgroundColor: pressed || focused ? (theme.isDark ? '#3C535D' : '#EDF7F5') : 'transparent' })}>
        <Image accessible={false} style={{ width: 48, height: 48, flexShrink: 0 }} resizeMode="contain"
          source={warning ? require('../../../../assets/my-reward-neutral-orange.png') : require('../../../../assets/my-reward-55.png')} />
        <View style={{ flex: 1, minWidth: 0, gap: 4 }}>
          <Text style={{ color: secondaryInk, fontSize: 14, lineHeight: 20, fontWeight: '600' }}>{t('my_rewards')}</Text>
          <View style={{ flexDirection: 'row', flexWrap: 'wrap', alignItems: 'baseline', columnGap: 8 }}>
            <Text style={{ color: ink, fontSize: 24, lineHeight: 30, fontWeight: '700', flexShrink: 1 }}>{currency}</Text>
            <Text style={{ color: secondaryInk, fontSize: 14, lineHeight: 22 }}>{`(${points})`}</Text>
          </View>
        </View>
        <View accessibilityElementsHidden importantForAccessibility="no-hide-descendants">
          <FontAwesomeIcon icon={faChevronRight} size={14} color={secondaryInk} />
        </View>
      </Pressable>
      <QualityWarningIndicator embedded />
      <ProfileBonusLink />
    </View>
  );
}
